import React, { useEffect, useRef, useState } from "react";
import { useSnackbar } from "notistack";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import ButtonYesno from "../../../components/buttons/button.yesno";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Changement de régime matrimonial avec apport ou biens déclarés
// Id simulateur 76

function parseNumber(value) {
  return parseInt(String(value || "").replace(/\D/g, "") || 0);
}

function getDefaultSpf() {
  return {
    valeur_spf: 0,
    epoux1: 0,
    epoux2: 0,
  };
}

const SPF_FIELDS = ["epoux1", "epoux2"];

function Simulateur_76(props) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const warningShown = useRef(false);
  const currentHash = window.location.hash;

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [valeur_biens_declares, setBiens] = useState(0);
  const [formalites_publication, setPubli] = useState(0);
  const [valeur_biens_immo, setBiensImmo] = useState(0);
  const [nombre_spf, setSPF] = useState(0);
  const [valeursSPF, setValeursSPF] = useState([]);
  const [csi_volontaire, setCsiVolontaire] = useState(0);
  const [nombre_enfants, setEnfants] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const handleChange = async (setter, value, key) => {
    if (typeof setter === "number") {
      functionSetValeursSPF(setter, value, key);
      return;
    }
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else {
      setter(value);
    }
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          valeur_biens_declares: parseInt(valeur_biens_declares),
          formalites_publication: parseInt(formalites_publication),
          valeur_biens_immo: parseInt(valeur_biens_immo),
          nombre_spf: parseInt(nombre_spf),
          csi_volontaire: parseInt(csi_volontaire),
          nombre_enfants: parseInt(nombre_enfants),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
          simulateur_76_bis: currentHash === "#bis" ? 1 : 0,
        },
        pdfInputs:{
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
        dependances: valeursSPF,
      };
      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) { object.departementid = parseInt(value); }
      if (setter === setBiens) { Object.assign(object["inputs"], { valeur_biens_declares: parseInt(value) }); }
      if (setter === setPubli) {Object.assign(object["inputs"], { formalites_publication: parseInt(value) }); }
      if (setter === setBiensImmo) { Object.assign(object["inputs"], { valeur_biens_immo: parseInt(value) }); }
      if (setter === setSPF) { Object.assign(object["inputs"], { nombre_spf: parseInt(value) }); }
      if (setter === setCsiVolontaire) { Object.assign(object["inputs"], { csi_volontaire: parseInt(value) }); }
      if (setter === setEnfants) { Object.assign(object["inputs"], { nombre_enfants: parseInt(value) }); }
      if (setter === setValeursSPF) { object.dependances = value; }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) { Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) }); }
      if (setter === props.setObjectConventionHonoraires) { Object.assign(object["pdfInputs"], { object_convention_honoraires : value }); }
      if (setter === props.setMontantConventionHonoraires) { Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)}); }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }
  useEffect(() => {
    if (props.isParent && props.simulateur?.id) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          valeur_biens_declares: parseInt(valeur_biens_declares),
          formalites_publication: parseInt(formalites_publication),
          valeur_biens_immo: parseInt(valeur_biens_immo),
          nombre_spf: parseInt(nombre_spf),
          csi_volontaire: parseInt(csi_volontaire),
          nombre_enfants: parseInt(nombre_enfants),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
          simulateur_76_bis: currentHash === "#bis" ? 1 : 0,
        },
        pdfInputs:{
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
        },
        dependances: valeursSPF,
      };
      dispatch(setSimulateurObject(object));
    }
  }, [
    dispatch,
    props.isParent,
    props.simulateur,
    departement,
    valeur_biens_declares,
    formalites_publication,
    valeur_biens_immo,
    nombre_spf,
    csi_volontaire,
    nombre_enfants,
    montantDeboursAdditionnels,
    deboursAdditionnels,
    props.conventionHonoraires,
    props.nombreConventionHonoraires,
    props.objectConventionHonoraires,
    props.montantConventionHonoraires,
    valeursSPF,
    currentHash,
  ]);

  useEffect(() => {
    const hasPublication = parseInt(formalites_publication) === 1;

    if (!hasPublication) {
      if (parseInt(nombre_spf) !== 0) {
        setSPF(0);
        setInRedux(setSPF, 0);
      }
      if (valeursSPF.length > 0) {
        setValeursSPF([]);
        setInRedux(setValeursSPF, []);
      }
      if (parseInt(valeur_biens_immo) !== 0) {
        setBiensImmo(0);
        setInRedux(setBiensImmo, 0);
      }
      if (parseInt(csi_volontaire) !== 0) {
        setCsiVolontaire(0);
        setInRedux(setCsiVolontaire, 0);
      }
      warningShown.current = false;
      return;
    }

    if (parseInt(nombre_spf) <= 0) {
      if (valeursSPF.length > 0) {
        setValeursSPF([]);
        setInRedux(setValeursSPF, []);
      }
      if (parseInt(valeur_biens_immo) !== 0) {
        setBiensImmo(0);
        setInRedux(setBiensImmo, 0);
      }
      if (parseInt(csi_volontaire) !== 0) {
        setCsiVolontaire(0);
        setInRedux(setCsiVolontaire, 0);
      }
      warningShown.current = false;
      return;
    }

    const nextValeursSPF = [];
    for (let i = 0; i < parseInt(nombre_spf); i++) {
      const currentValue = valeursSPF[i] || getDefaultSpf();
      const epoux1 = parseNumber(currentValue.epoux1);
      const epoux2 = parseNumber(currentValue.epoux2);
      nextValeursSPF[i] = {
        ...getDefaultSpf(),
        ...currentValue,
        epoux1,
        epoux2,
        valeur_spf: epoux1 + epoux2,
      };
    }

    if (JSON.stringify(nextValeursSPF) !== JSON.stringify(valeursSPF)) {
      setValeursSPF(nextValeursSPF);
      setInRedux(setValeursSPF, nextValeursSPF);
    }
  }, [nombre_spf, formalites_publication]);

  useEffect(() => {
    if (parseInt(formalites_publication) !== 1) {
      return;
    }

    let nextValeurBiensImmo = 0;
    let nextCsiVolontaire = 0;
    let showWarning = false;

    for (let i = 0; i < valeursSPF.length; i++) {
      const epoux1 = parseNumber(valeursSPF[i]?.epoux1);
      const epoux2 = parseNumber(valeursSPF[i]?.epoux2);

      if (epoux1 === epoux2 && epoux1 > 0) {
        nextCsiVolontaire += epoux1 + epoux2;
        showWarning = true;
      } else if (epoux1 !== epoux2) {
        nextValeurBiensImmo += Math.abs(epoux1 - epoux2) / 2;
      }
    }

    if (parseInt(valeur_biens_immo) !== parseInt(nextValeurBiensImmo)) {
      setBiensImmo(nextValeurBiensImmo);
      setInRedux(setBiensImmo, nextValeurBiensImmo);
    }

    if (parseInt(csi_volontaire) !== parseInt(nextCsiVolontaire)) {
      setCsiVolontaire(nextCsiVolontaire);
      setInRedux(setCsiVolontaire, nextCsiVolontaire);
    }

    if (showWarning && warningShown.current === false) {
      enqueueSnackbar("Une CSI sera appliquée si vous renseignez les deux champs même s'ils sont égaux.", {
        variant: "warning",
      });
    }
    warningShown.current = showWarning;
  }, [valeursSPF, formalites_publication, valeur_biens_immo, csi_volontaire]);

  function functionSetValeursSPF(index, field, value) {
    if (!SPF_FIELDS.includes(field) && SPF_FIELDS.includes(value)) {
      const nextField = value;
      value = field;
      field = nextField;
    }

    if (!SPF_FIELDS.includes(field)) {
      return;
    }

    const nextValeursSPF = [...valeursSPF];
    nextValeursSPF[index] = {
      ...getDefaultSpf(),
      ...nextValeursSPF[index],
    };
    nextValeursSPF[index][field] = parseNumber(value);
    nextValeursSPF[index].valeur_spf =
      parseNumber(nextValeursSPF[index].epoux1) + parseNumber(nextValeursSPF[index].epoux2);
    setValeursSPF(nextValeursSPF);
    setInRedux(setValeursSPF, nextValeursSPF);
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Acte tarifé au titre du Tableau 5, n° 41 (Art A444-82). Dans l’hypothèse où aucune formalité de publication au
          service de la publicité foncière n’est requise, la provision sur frais calculée ne prévoit pas les éventuels
          frais de l’acte de dépôt pour constater l’absence d’opposition.
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quelle est la valeur des biens déclarés et/ou apportés ?
            <ToolTipPerso
              title={"Ce champ doit être rempli pour calculer les émoluments, il peut comprendre des biens meubles et immeubles et doit correspondre à 100% de la valeur apportée par les époux"}
            />
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la valeur"}
            setter={setBiens}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Est-il prévu des formalités de publication au service de la publicité foncière ?
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPubli} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {parseInt(formalites_publication) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Indiquer le nombre de SPF</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le nombre"}
              setter={setSPF}
            />
          </div>
        ) : (
          <></>
        )}

        {parseInt(formalites_publication) === 1 && valeursSPF.length > 0 ? (
          valeursSPF.map((valeur, index) => (
            <div key={index} style={styles.cardRowChild}>
              <div className="cardRow">
                <div style={{ ...styles.cardElemVerticalyCenter, paddingRight: 24 }}>
                  Quelle est la valeur des biens apportés relevant de la SPF {index + 1} ?
                  {currentHash !== "#bis" && (
                    <ToolTipPerso
                      title={"Exemples : bien propre ou personnel de Monsieur, indiquer 100 dans le champ 1 et 0 dans le champ 2, bien indivis à hauteur de 30 % pour Monsieur et 70 % pour Madame, indiquer 30 dans le champ 1 et 70 dans le champ 2"}
                    />
                  )}
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 18,
                    width: "100%",
                  }}
                >
                  <div>
                    <div style={{ marginBottom: 8, color: "#5E91B6", textAlign: "center", fontSize: 14 }}>Époux 1</div>
                    <TextfieldNumber
                      handleChange={handleChange}
                      type={"number"}
                      placeholder={"Indiquer la valeur"}
                      index={index}
                      keyName={"epoux1"}
                      defaultValue={valeur?.epoux1}
                    />
                  </div>
                  <div>
                    <div style={{ marginBottom: 8, color: "#5E91B6", textAlign: "center", fontSize: 14 }}>Époux 2</div>
                    <TextfieldNumber
                      handleChange={handleChange}
                      type={"number"}
                      placeholder={"Indiquer la valeur"}
                      index={index}
                      keyName={"epoux2"}
                      defaultValue={valeur?.epoux2}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}

        {currentHash !== "#bis" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Combien y a-t-il d’enfant(s) majeur(s) ?</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le nombre"}
              setter={setEnfants}
            />
          </div>
        ) : (
          <></>
        )}

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_76;
